<script lang="ts">
  import { parseUrl } from "$lib/utils/helpers.js";

  // Props
  export let buttonText: string;
  export let buttonLink: string;
  export let textColor: string | null = null;
  export let buttonColor: string | null = null;
</script>

<a
  href={parseUrl(buttonLink)}
  class="arrow-button scale-up-on-hover"
  style:color={textColor || null}
  style:background-color={buttonColor || null}
>
  {buttonText}
  <span class="arrow-button-arrow">→</span>
</a>

<style lang="postcss">
  .arrow-button {
    display: inline-block;
    padding: 10px 16px;
    font-size: 14px;
    font-weight: 500;
    color: #ffffff;
    background-color: #365cd1;
    border-radius: 4px;
    text-decoration: none;

    &:hover {
      filter: brightness(120%);
    }

    &:focus {
      outline: none;
    }

    &:focus-visible {
      outline: 2px solid #febb39;
      outline-offset: -3px;
    }
  }

  .arrow-button-arrow {
    margin-left: 1.5rem;
    font-weight: bold;
  }
</style>
